import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";

export default function Home(props) {
  useEffect(() => {
        document.title = 'Modular - ATHIS';
      }, []);
      
  return (
    <Box className="home maincontent">
      <div className="home_content" >
        <h3> Moradia Digna</h3>
        <h4> é um direito de todos.</h4>
        <Link to="/sobre"><Button >Saiba Mais</Button></Link>
      </div>
    </Box>
  );
}